/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-expressions: 0, babel/no-unused-expressions: 0, no-unused-vars: 0, no-var: 0 */
/* globals _ */

_.namespace(`Backbone`, function(BB) {
  'use strict';

  _.extend(BB.View.prototype, {
    // clean up method for Backbone Views
    close() {
      this.trigger(`close`);
      this.remove();
      this.off();
    },

    // helper for adding a custom cleanup handler
    //
    // ex: (in view)
    //  this.on_close(function() { this.sub_view.close(); });
    on_close(callback) {
      var cb = _.bind(function() {
        this.off(null, cb);
        callback.call(this);
      }, this);

      this.on(`close`, cb);
    },
  });

  _.extend(BB.History.prototype, {
    compareUrlFragments(fragment1, fragment2) {
      return fragment1 === fragment2 || decodeURIComponent(fragment1) === decodeURIComponent(fragment2);
    },

    // mostly a copy of backbone's implementation but works for special chars in firefox
    checkUrl(ev) {
      var current = this.getFragment();
      if (this.compareUrlFragments(current, this.fragment) && this.iframe) { current = this.getFragment(this.getHash(this.iframe)); }
      if (this.compareUrlFragments(current, this.fragment)) { return false; }
      if (this.iframe) { this.navigate(current); }
      if (!this.loadUrl()) {
        this.loadUrl(this.getHash());
      }
    },
  });

  _.extend(BB.Collection.prototype, {
    findWhere(properties) {
      return this.find(function(model) {
        var attrs = model.pick(_.keys(properties));
        return _.isEqual(properties, attrs);
      });
    },

    // exactly the same as our version of backbone's reset method
    // except that it adds the "previousModels" to the options
    // like in Backbone 0.9.9
    reset(models, options) {
      models || (models = []);
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger(`reset`, this, options);
      return this;
    },
  });

  _.extend(BB.Model.prototype, {
    pick() {
      var args = Array.prototype.concat.apply([this.attributes], arguments);
      return _.pick.apply(_, args);
    },
  });
});

}.call(window));